import * as _ from 'lodash';

import { BaseTable } from '../common-models/base-table.model';
import tableDictionary from './dictionary/calibration-parking.dictionary';
import tableSettings from './settings/parking-table.settings';
import { CalibrationParkingValue } from '../calibrations/calibration-parking-value.model';

import { TableType } from '../../../shared/enums';

export class ParkingTable extends BaseTable {

    constructor() {
        super(tableSettings, tableDictionary);
        this.calibrationType = TableType.CALIBRATION_PARKING;
    }

    public updateData(savedData: CalibrationParkingValue[]): boolean {
        if (!this.isInitialized) {
            return false;
        }
        savedData.forEach((updatedCalibrationParking) => {
            const calibrationParkingIndex =
                _.findIndex(this.table, (cell) => {
                     return cell.value.currentState.ZoneCombinationId === updatedCalibrationParking.ZoneCombinationId &&
                         cell.value.currentState.OverlayTypologyId === updatedCalibrationParking.OverlayTypologyId;
                });
            this.table[calibrationParkingIndex].value =
                new CalibrationParkingValue(updatedCalibrationParking, this.settings.fieldValidation);
        });

        return true;
    }
}
